import type { OrderDeliveryMethod, StatusLabel } from "../constants/order-display.constants";
import { getString } from "../uistringlabels/ui-string-utils";

export const statusLabelText = (statusLabel: StatusLabel): string =>
  getString(`orderDisplay.statusLabels.${statusLabel}`);

export const deliveryMethodLabel = (deliveryMethod: OrderDeliveryMethod): string =>
  getString(`orderDisplay.deliveryMethods.${deliveryMethod}`);
